import React, { useContext, useMemo, useState } from "react";
import Image from "next/image";
import nftInstructions4 from "../public/faqs/nft-instructions-4.png";
import Spacer from "./Spacer";
import { useWindowSize } from "../utils/hooks";
import nftInstructions5 from "../public/faqs/nft-instructions-5.png";
import { ToggleButtons } from "./ToggleButtons";
import { MediaQueryContext } from "../context/mediaQuery/context";

const ImageToggle: React.FC = () => {
  const {
    state: { tablet },
  } = useContext(MediaQueryContext);

  const windowSize = useWindowSize();
  const ratio = windowSize.width ? windowSize.width / 414 : 1;
  const memeWidth = useMemo(
    () => (tablet ? 300.6228373702 * Math.min(ratio, 1) : 362),
    [tablet, ratio]
  );
  const nftInstructionsWidth = useMemo(
    () => (tablet ? 240 * Math.min(ratio, 1) : 289),
    [tablet, ratio]
  );
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={"column ai-center"}>
      <ToggleButtons
        items={["Meme", "xNFT"]}
        selectedIndex={selectedIndex}
        onSelectIndex={(index) => setSelectedIndex(index)}
      />
      <Spacer height={20} />
      <div className={"column ai-center relative"}>
        <div
          style={{
            width: nftInstructionsWidth,
            opacity: selectedIndex === 1 ? 1 : 0,
          }}
        >
          <Image
            width={nftInstructionsWidth}
            height={tablet ? 386 * (nftInstructionsWidth / 289) : 386}
            src={nftInstructions4}
            alt={"xNFT"}
            layout={"fixed"}
          />
        </div>

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            opacity: selectedIndex === 0 ? 1 : 0,
          }}
        >
          <Image
            width={memeWidth}
            height={tablet ? 386 * (memeWidth / 362) : 386}
            src={nftInstructions5}
            alt={"meme"}
            layout={"fixed"}
          />
        </div>
      </div>
    </div>
  );
};

export { ImageToggle };
